import { render, staticRenderFns } from "./ThemeItem.vue?vue&type=template&id=2d920f89&scoped=true"
import script from "./ThemeItem.vue?vue&type=script&lang=js"
export * from "./ThemeItem.vue?vue&type=script&lang=js"
import style0 from "./ThemeItem.vue?vue&type=style&index=0&id=2d920f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d920f89",
  null
  
)

export default component.exports